import React from 'react';
import { Check, Lock, Zap, ShieldCheck, Mail } from 'lucide-react';
export function Pricing() {
  return <section id="pricing" className="py-20 bg-slate-50 px-4" data-id="element-213">
      <div className="max-w-6xl mx-auto" data-id="element-214">
        <div className="text-center mb-16" data-id="element-215">
          <h2 className="text-3xl md:text-4xl font-bold text-navy mb-4" data-id="element-216">
            Accedé al Mega Pack ahora
          </h2>
          <p className="text-lg text-slate-600 max-w-2xl mx-auto" data-id="element-217">
            Ambas opciones incluyen las 6 guías completas. La diferencia está en
            los 4 bonus estratégicos.
          </p>
        </div>

        <div className="flex flex-col lg:flex-row gap-8 max-w-5xl mx-auto items-center lg:items-stretch" data-id="element-218">
          {/* Opción 1: Pack Esencial */}
          <div className="w-full lg:w-1/2 bg-white rounded-3xl p-8 border border-slate-200 shadow-sm flex flex-col" data-id="element-219">
            <div className="inline-block bg-slate-100 text-slate-600 font-bold text-xs px-3 py-1 rounded-full mb-6 w-fit" data-id="element-220">
              AHORRÁS $15.000
            </div>

            <h3 className="text-2xl font-bold text-navy mb-2" data-id="element-221">Pack Esencial</h3>
            <p className="text-slate-500 text-sm mb-6 h-10" data-id="element-222">
              Las 6 guías completas. Todo lo que necesitás para arrancar.
            </p>

            <div className="mb-8" data-id="element-223">
              <span className="text-slate-400 line-through text-lg block mb-1" data-id="element-224">
                $34.990
              </span>
              <div className="flex items-baseline gap-1" data-id="element-225">
                <span className="text-4xl font-extrabold text-navy" data-id="element-226">
                  $19.990
                </span>
                <span className="text-slate-500" data-id="element-227">ARS</span>
              </div>
              <p className="text-sm text-slate-500 mt-2" data-id="element-228">
                Pago único · Acceso inmediato
              </p>
            </div>

            <div className="space-y-4 mb-8 flex-grow" data-id="element-229">
              <p className="font-semibold text-navy text-sm" data-id="element-230">Incluye:</p>
              <ul className="space-y-3" data-id="element-231">
                {['Guía 1: Mentalidad y Posicionamiento Digital', 'Guía 2: Conocé a tu Cliente Ideal', 'Guía 3: Contenido que Vende sin Vender', 'Guía 4: El Arte de Captar Atención', 'Guía 5: Publicidad Paga sin Desperdiciar Plata', 'Guía 6: Del Seguidor al Comprador'].map((item, i) => <li key={i} className="flex items-start gap-2 text-sm text-slate-700" data-id="element-232">
                    <Check className="w-5 h-5 text-green-500 shrink-0" data-id="element-233" />
                    <span data-id="element-234">{item}</span>
                  </li>)}
              </ul>
            </div>

            <a href="https://checkout.saberclick.com/products/pack-publicidad-en-redes-sociales?variant=50294396780737" target="_blank" rel="noopener noreferrer" className="block w-full text-center bg-white border-2 border-navy text-navy hover:bg-slate-50 font-bold py-4 rounded-xl transition-colors" data-id="element-235">
              Quiero el pack esencial
            </a>
            <p className="text-center text-xs text-slate-500 mt-3" data-id="element-236">
              Pago seguro · PDF descargable
            </p>
          </div>

          {/* Opción 2: Megapack Completo (Destacada) */}
          <div className="w-full lg:w-1/2 bg-navy rounded-3xl p-8 border-2 border-sky shadow-[0_0_30px_rgba(56,189,248,0.2)] relative flex flex-col transform lg:-translate-y-4" data-id="element-237">
            <div className="absolute -top-4 left-1/2 -translate-x-1/2 bg-sky text-navy font-bold text-sm px-4 py-1 rounded-full flex items-center gap-1 shadow-md whitespace-nowrap" data-id="element-238">
              <span data-id="element-239">⭐</span> MÁS ELEGIDO
            </div>

            <div className="inline-block bg-sky/20 text-sky font-bold text-xs px-3 py-1 rounded-full mb-6 w-fit mt-2" data-id="element-240">
              AHORRÁS $15.000 + $39.960 en bonus
            </div>

            <h3 className="text-2xl font-bold text-white mb-2" data-id="element-241">
              Megapack Completo
            </h3>
            <p className="text-slate-300 text-sm mb-6 h-10" data-id="element-242">
              Las 6 guías + los 4 bonus estratégicos. La opción completa.
            </p>

            <div className="mb-8" data-id="element-243">
              <span className="text-slate-400 line-through text-lg block mb-1" data-id="element-244">
                $44.990
              </span>
              <div className="flex items-baseline gap-1" data-id="element-245">
                <span className="text-5xl font-extrabold text-white" data-id="element-246">
                  $29.990
                </span>
                <span className="text-sky" data-id="element-247">ARS</span>
              </div>
              <p className="text-sm text-slate-300 mt-2" data-id="element-248">
                Pago único · Todo incluido · Acceso inmediato
              </p>
            </div>

            <div className="space-y-4 mb-8 flex-grow" data-id="element-249">
              <p className="font-semibold text-white text-sm" data-id="element-250">Incluye:</p>
              <ul className="space-y-3" data-id="element-251">
                <li className="flex items-start gap-2 text-sm text-slate-200 font-medium border-b border-white/10 pb-3 mb-3" data-id="element-252">
                  <Check className="w-5 h-5 text-sky shrink-0" data-id="element-253" />
                  <span data-id="element-254">Todo el Pack Esencial incluido</span>
                </li>
                {['Bonus 1: Kit de 30 ideas de contenido', 'Bonus 2: Guía de hashtags y algoritmos 2025', 'Bonus 3: Scripts de venta para DMs', 'Bonus 4: Checklist de lanzamiento completo'].map((item, i) => <li key={i} className="flex items-start gap-2 text-sm text-slate-200" data-id="element-255">
                    <span className="text-xl leading-none" data-id="element-256">🎁</span>
                    <span data-id="element-257">{item}</span>
                  </li>)}
              </ul>
            </div>

            <a href="https://checkout.saberclick.com/products/megapack-publicidad-en-redes-sociales?variant=50294409199809" target="_blank" rel="noopener noreferrer" className="block w-full text-center bg-sky hover:bg-sky-hover text-navy font-bold text-lg py-4 rounded-xl transition-all shadow-[0_0_15px_rgba(56,189,248,0.5)] hover:scale-[1.02]" data-id="element-258">
              💥 SÍ, QUIERO EL MEGAPACK AHORA
            </a>
            <p className="text-center text-xs text-slate-300 mt-3" data-id="element-259">
              La opción más elegida por emprendedores que quieren resultados
              rápidos
            </p>
          </div>
        </div>

        <div className="flex flex-wrap justify-center gap-6 mt-12 text-sm font-medium text-slate-500" data-id="element-260">
          <div className="flex items-center gap-2" data-id="element-261">
            <Lock className="w-4 h-4" data-id="element-262" />
            <span data-id="element-263">Pago seguro</span>
          </div>
          <div className="flex items-center gap-2" data-id="element-264">
            <Zap className="w-4 h-4" data-id="element-265" />
            <span data-id="element-266">Acceso en minutos</span>
          </div>
          <div className="flex items-center gap-2" data-id="element-267">
            <ShieldCheck className="w-4 h-4" data-id="element-268" />
            <span data-id="element-269">Garantía 7 días</span>
          </div>
          <div className="flex items-center gap-2" data-id="element-270">
            <Mail className="w-4 h-4" data-id="element-271" />
            <span data-id="element-272">Soporte por mail</span>
          </div>
        </div>
      </div>
    </section>;
}